import { makeStyles } from 'tss-react/mui';
export default makeStyles()(function (theme) {
  return {
    root: {},
    primary: {
      '& svg': {
        fill: theme.palette.primary[900]
      }
    }
  };
});